import { useMutation } from "@tanstack/react-query";
import { useState } from "react";

import { useToast } from "@/components/hooks/use-toast";
import { Button } from "@/components/ui/button";
import { logEmail } from "@/lib/api";
import { cn } from "@/lib/utils";

export function GetStartedNewsroom({ center = false }: { center?: boolean }) {
  const [email, setEmail] = useState("");
  const { toast } = useToast();
  const onSubmit = useMutation({
    mutationFn: () => logEmail(email),
    onSuccess: () => {
      toast({
        title: "Email logged",
        description: "You will be contacted by our team soon!",
      });
    },
    onError: () => {
      toast({
        title: "Error logging email",
        description: "Please try again",
      });
    },
  });

  return (
    <form
      className={cn("flex gap-2", center && "justify-center")}
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit.mutate();
      }}
    >
      <input
        required
        type="email"
        placeholder="your_email@newsroom.com"
        className={cn(
          "max-w-md w-full bg-transparent rounded-lg border-2 border-slate-6 dark:border-slatedark-6 px-4 placeholder:text-slate-4 dark:placeholder:text-slate-4",
        )}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <Button size="lg" variant="inverted" type="submit">
        Get Started
      </Button>
    </form>
  );
}
